import { render, staticRenderFns } from "./QtdEmpresas.vue?vue&type=template&id=65f9f135"
import script from "./QtdEmpresas.vue?vue&type=script&lang=js"
export * from "./QtdEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports